var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgDetails = function SvgDetails(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Details_svgr__clip0_360_690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.922 6.516A5.91 5.91 0 006.016.609 5.91 5.91 0 00.109 6.516a5.91 5.91 0 005.907 5.906 5.884 5.884 0 003.85-1.433l2.778 2.778.623-.623-2.778-2.778a5.884 5.884 0 001.433-3.85zm-5.906 5.03a5.032 5.032 0 11.001-10.063 5.032 5.032 0 01-.001 10.064z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8 3.88l.678.558a3.264 3.264 0 012.538-1.204V2.36A4.17 4.17 0 002.8 3.88zM1.86 6.516h.874c0-.23.022-.449.066-.668l-.853-.175a4.315 4.315 0 00-.088.843z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Details_svgr__clip0_360_690"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .5)",
    d: "M0 0h14v14H0z"
  })))));
};

export default SvgDetails;